module.exports = __webpack_public_path__ + "img/sand-dune-decal-21.964d230c.png";